module.exports = __webpack_public_path__ + "img/terroir-bright-3-mobile.a2c7f3a2.jpg";